<ng-container *ngIf="loaded && company; else loadingShop">
    <section class="profile-subsection">
        <h4>{{ "Shop Name" | translate }}</h4>
        <form [formGroup]="shopNameForm" (ngSubmit)="saveShopName()" class="mt-3">
            <div class="form-group">
                <input
                    type="text"
                    class="form-control"
                    formControlName="shopName"
                    maxlength="30"
                    [class.is-invalid]="shopNameForm.get('shopName').invalid && shopNameForm.get('shopName').touched"
                />
            </div>
            <div class="d-flex justify-content-end" *ngIf="user?.type === 'pro'">
                <button type="submit" class="btn btn-primary" [disabled]="shopNameForm.invalid || savingShopName">
                    {{ "Save" | translate }}
                </button>
            </div>
        </form>
    </section>

    <div class="separator my-4"></div>

    <section class="profile-subsection">
        <h4>{{ "Logo" | translate }}</h4>
        <div class="d-flex justify-content-center align-items-center flex-column gap-3 mt-3">
            <ng-container *ngIf="cpLoading; else displayCompanyPicture">
                <div class="py-4 text-center">
                    <app-loader></app-loader>
                </div>
            </ng-container>
            <ng-template #displayCompanyPicture>
                <div class="d-inline-block position-relative">
                    <app-picture
                        [picture]="company.picture"
                        [default]="company.initials"
                        size="100"
                        format="circle"
                    ></app-picture>
                    <button
                        type="button"
                        class="btn btn-sm change-picture"
                        (click)="changeCompanyPicture()"
                        *ngIf="user?.type === 'pro'"
                    >
                        <i class="bi bi-arrow-repeat"></i>
                    </button>
                </div>
            </ng-template>
        </div>
    </section>

    <div class="separator my-4"></div>

    <section class="profile-subsection">
        <h4>{{ "Header" | translate }}</h4>
        <p>
            {{ "company_header_explanation" | translate }}
        </p>
        <app-image-upload [loading]="cshLoading" [progress]="cshProgress" size="750x150">
            <app-picture *ngIf="company.searchHeader" [picture]="company.searchHeader" size="750x150"></app-picture>
        </app-image-upload>
        <button
            type="button"
            class="btn btn-primary px-3 mt-3"
            (click)="changeCompanySearchHeader()"
            *ngIf="user?.type === 'pro'"
        >
            <i class="bi bi-pencil-fill me-2"></i> <span>{{ "Edit" | translate }}</span>
        </button>
    </section>
</ng-container>
<ng-template #loadingShop>
    <div class="text-center py-4"><app-loader></app-loader></div>
</ng-template>
